import currency from "currency.js";
import { numberDecimalSeparator, numberGroupSeparator } from "./numberUtils";

interface Options {
  hideCents: boolean
  symbolLeft: boolean
}

const defaultOptions: Options = {
  hideCents: false,
  symbolLeft: false
};

const getCurrencyOptions = (currencyName: server.dto.Currencies, locale: string, options: Partial<Options>) => ({
  separator: numberGroupSeparator(locale),
  decimal: numberDecimalSeparator(locale),
  pattern: options.symbolLeft ? "! #" : "# !", // # means the number, ! means the symbol, so it gets formatted like 10,50 EUR
  negativePattern: options.symbolLeft ? "! -#" : "-# !", // same as above, except for negative numbers
  symbol: currencyName.toUpperCase(),
  formatWithSymbol: true,
  precision: options.hideCents ? 0 : 2,
  increment: 0.01
});

export const formatCurrency = (value: number | currency, currencyName: server.dto.Currencies, locale: string, opts?: Partial<Options>): string => {
  const options = opts || defaultOptions;

  let formatter: currency;

  if (typeof value === "number") {
    formatter = currency(value, getCurrencyOptions(currencyName, locale, options));
  } else {
    formatter = currency(value.value, getCurrencyOptions(currencyName, locale, options));
  }

  return formatter.format();
};
